import type { ComputeRule } from '../core/schema/types';

function applyComputeRulesForValidation(
  edits: Record<string, unknown>,
  applyComputeRules?: (row: Record<string, unknown>, changedField: string) => Record<string, unknown>,
  computeSourceFields?: ReadonlyArray<string>,
  computeRules?: ReadonlyArray<ComputeRule>,
): Record<string, unknown> {
  if (!applyComputeRules || !computeSourceFields?.length) return edits;

  let prepared = { ...edits };
  for (const field of computeSourceFields) {
    const rulesForSource = computeRules?.filter((r) => r.sourceFields.includes(field)) ?? [];
    const targetExplicitlyEdited = rulesForSource.some((rule) =>
      Object.prototype.hasOwnProperty.call(edits, rule.targetField),
    );
    if (targetExplicitlyEdited) {
      continue;
    }
    prepared = applyComputeRules(prepared, field);
  }
  return prepared;
}

export function mergeRowForValidation(
  original: Record<string, unknown> | undefined,
  edits: Record<string, unknown>,
  applyComputeRules?: (row: Record<string, unknown>, changedField: string) => Record<string, unknown>,
  computeSourceFields?: ReadonlyArray<string>,
  computeRules?: ReadonlyArray<ComputeRule>,
): Record<string, unknown> {
  const preparedEdits = applyComputeRulesForValidation(
    edits,
    applyComputeRules,
    computeSourceFields,
    computeRules,
  );
  return original ? { ...original, ...preparedEdits } : { ...preparedEdits };
}
